export const extractErrorMessage = (error, defaultMsg = 'Si è verificato un errore') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => e?.msg || 'Errore di validazione').join(', ');
  }
  return error?.message || defaultMsg;
};
